import { Box, Divider, Stack, Typography } from '@mui/material';
import { NegotiationBoundary } from '@procureai/schemas';
import { formatNumber, NumberFormatPreset } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

const formatPercent = formatNumber(NumberFormatPreset.PERCENT_DECIMAL);

export const NegotiationBoundaryListItem = ({
  base,
  lower,
  upper,
  sequence,
}: NegotiationBoundary & { sequence: number }) => {
  const { t: tBase } = useTranslation(undefined, { keyPrefix: 'NegotiationBoundaryBase' });
  const { t } = useTranslation('modules', { keyPrefix: 'NegotiationBoundariesForm' });
  const normalizedSequence = sequence + 1;

  return (
    <Stack direction="column" spacing={2} sx={{ mt: 2 }}>
      <Box>
        <Typography variant="body1">{`${normalizedSequence}. ${tBase(base)}`}</Typography>
      </Box>

      <Box sx={{ pl: 4 }}>
        <Stack direction="column" spacing={2}>
          <Stack direction="row" spacing={2}>
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>
                {t('boundaries.upper.label')}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>
                {formatPercent(upper)}
              </Typography>
            </Box>
          </Stack>
          <Stack direction="row" spacing={2}>
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>
                {t('boundaries.lower.label')}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>
                {formatPercent(lower)}
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </Box>
      <Divider />
    </Stack>
  );
};
